import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../static/Footer";
import Header from "../static/Header";

import { ChatWidget } from "../CustomerSupport/ChatWidget";

const WebLayout: React.FC = () => {
  return (
    <div className="overflow-x-clip">
      <a href="#main-content" className="sr-only fixed left-4 top-4 z-[100] rounded bg-white px-4 py-3 font-semibold text-black shadow focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-orange-600">Skip to main content</a>
      <Header />
      <div id="main-content" tabIndex={-1}>
        <Outlet />
      </div>
      <ChatWidget />
      <Footer />
    </div>
  );
};

export default WebLayout;
